import React from 'react';
import immutable from 'immutable';
import Popover from 'components/pure/utils/Popover';
import RadioField from 'components/pure/utils/form/RadioField';
import {stripHtmlWithSpaces} from 'utils/stripHtml';
import {htmlDecode} from 'components/triggers/BulletedMatchedRuleDescription';
import 'styles/sharing/DirectCallSharingDialog.styl';
import SharingFormActions from 'actions/sharing/SharingFormActions';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {createStyles, withStyles} from '@material-ui/core/styles';

/**
 * FileUploadSharingDialogFormContentToShare uses the `react-select` framework to implement
 * a <Select /> dropdown that allows a user to pick / select which content to share along with a call
 */
class FileUploadSharingDialogFormContentToShare extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      previousValue: immutable.List(),
      isFullCall: false,
    };

    this.selectOptions = [
      {value: 'fullCall', label: 'Full call'},
      {value: 'highlights', label: 'Selected highlights'},
    ];
    this.handleScroll = this.handleScroll.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.contentToShare && nextProps.contentToShare !== this.props.contentToShare) {
      this.setState({isFullCall: this.isFullCall(nextProps.contentToShare)});
    }
  }

  componentWillUnmount() {
    if (this.throttledScrollHandler) {
      this.scrollDiv.removeEventListener('scroll', this.throttledScrollHandler);
      this.throttledScrollHandler = null;
    }
  }

  handleScroll() {
    if (this.inputRef) {
      this.inputRef.blur();
    }
  }

  onChange(value) {
    SharingFormActions.updateContentToShare(value);
    this.props.onDataChanged(value.value);
  }

  hasHighlights(contentToShare) {
    return contentToShare && contentToShare.value === 'highlights';
  }

  isFullCall(contentToShare) {
    return contentToShare && contentToShare.value === 'fullCall';
  }

  /**
   * Callback when the user selects a tag
   * @param  {array} values array of selected {value: 'tag.id', label: 'tag.content'} objects
   */
  onChangeHighlights = (_event, values) => {
    SharingFormActions.updateSelectedHighlights(values);
    this.props.onDataChanged();
  };

  render() {
    const highlightsClassName = this.props.highlightsError ? 'error-field' : '';
    // See similar code in FileUploadSharingDialogFormComments for more comments on the next few lines
    const {errorAnchor} = this.props;
    const anchor = errorAnchor || this.highlightsSelect;
    const targetOrigin = {
      horizontal: 'left',
      vertical: errorAnchor ? 'bottom' : 'center',
    };
    const label = errorAnchor ? '' : 'contents';
    const options = this.props.highlights.map(highlight => ({
      label: htmlDecode(stripHtmlWithSpaces(highlight.message)),
      value: highlight.id,
    }));

    const selected = this.props.selectedHighlights.map(opt => ({
      label: htmlDecode(stripHtmlWithSpaces(opt.label)),
      value: opt.value,
    }));

    return (
      <div>
        <div className="overflow">
          <div className="text-input-label">Content to share</div>
          <div className="content content-to-share">
            {this.selectOptions.map(item => (
              <div key={item.value}>
                <RadioField
                  label={item.label}
                  checked={
                    this.props.contentToShare && this.props.contentToShare.value === item.value
                  }
                  onClick={event => this.onChange(item)}
                />
                {item.value === 'fullCall' && <div ref={c => (this.fullCall = c)}></div>}
              </div>
            ))}
          </div>
          <Popover
            open={!!this.props.contentToShareError}
            canAutoPosition={true}
            useLayerForClickAway={false}
            anchorEl={this.fullCall}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            targetOrigin={{horizontal: 'left', vertical: 'bottom'}}>
            <div className="sharing-dialog-popover-error-message">
              {this.props.contentToShareError}
            </div>
          </Popover>
        </div>
        {this.hasHighlights(this.props.contentToShare) && (
          <div className="overflow highlights-select">
            <RaisedAutocomplete
              ref={c => this.props.onShownRef('highlights', c)}
              className={highlightsClassName}
              multiple
              fullWidth
              autoHighlight
              filterSelectedOptions
              renderInput={params => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder={selected.length === 0 ? 'Select highlights...' : ''}
                />
              )}
              options={options}
              getOptionLabel={o => o.label}
              value={selected}
              getOptionSelected={(option, value) => option.value === value.value}
              onChange={this.onChangeHighlights}
              noOptionsText={`You don't have any highlights on this call`}
              ChipProps={{
                size: 'small',
                variant: 'outlined',
                style: {
                  maxWidth: '300px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
            />
            <div className="error-anchor" ref={c => (this.highlightsSelect = c)}></div>
            <Popover
              open={!!this.props.highlightsError}
              canAutoPosition={false}
              useLayerForClickAway={false}
              anchorEl={anchor}
              anchorOrigin={{horizontal: 'right', vertical: 'center'}}
              targetOrigin={targetOrigin}>
              <div
                className="sharing-dialog-popover-error-message"
                ref={c => this.props.onPopoverRef(label, c)}>
                {this.props.highlightsError}
                {this.props.errorAnchor && (
                  <div className="more-errors-down"> (Please scroll down)</div>
                )}
              </div>
            </Popover>
          </div>
        )}
      </div>
    );
  }
}

// TODO Remove me when dialog is changed to muiv4
const RaisedAutocomplete = withStyles(theme =>
  createStyles({
    popper: {
      zIndex: 1501,
    },
  })
)(Autocomplete);

export default FileUploadSharingDialogFormContentToShare;
